<template>
    <input ref="inp"
           :type="type" class="form-control"
           :required="options.required"
           :value="value"
           @input="inputHandler"
           @click="$emit('click', $event.target.value)"
           @focus="$emit('focus')"
           @blur="blurHandler"
           @key.prevent=""
           @invalid.prevent="invalidHandler"
           :minlength="options.minLength"
           :maxlength="options.maxLength"
    />
</template>

<script>
    const allowedTypes = ['text', 'password', 'email', 'number', 'search', 'tel', 'url'];

    export default {
        name: 'simple-input',
        props: {
            type: {
                type: String,
                default: 'text'
            },
            value: undefined,
            options: {
                type: Object,
                default: () => {return {}}
            },
        },
        methods: {
            inputHandler(e) {
                if (this.type === 'email') {
                    if (!this.validateEmail(e.target.value)) {
                        this.$refs.inp.setCustomValidity('Неправильный email адрес');
                    } else {
                        this.$refs.inp.setCustomValidity('');
                    }
                }
                this.$emit('input', e.target.value)
            },
            blurHandler(e) {
                this.$emit('blur');
                if (!e.target.checkValidity()) {
                    this.$emit('invalid', e.target.validationMessage);
                }
            },
            invalidHandler(e) {
                this.$emit('invalid', e.target.validationMessage);
            },
            validateEmail(email) {
                let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
            }
        },
        created() {
            if (!allowedTypes.includes(this.type)) {
                console.warn('Not allowed field type!')
            }
        }

    }
</script>

<style scoped>

</style>
